/* KingCase - option "On fait la maquette pour vous".
   Ajoute un ecran de choix a l'ouverture de l'appli :
   - "On fait la maquette pour vous" : taille + photos droite/gauche + infos facultatives
   - "Je cree ma maquette" : l'appli complete, inchangee
   Depend de assets/kingcase-perso.js (charge avant). */
(function(){
  var tries = 0;
  function boot(){
    var HOST = document.querySelector('[data-kc-host]');
    var ROOT = HOST && HOST.shadowRoot;
    var wrap = ROOT && ROOT.querySelector('.wrap');
    if(!wrap){ if(tries++ < 80) setTimeout(boot, 150); return; }
    if(HOST.dataset.kcSimple) return;
    HOST.dataset.kcSimple = '1';
    init(HOST, ROOT, wrap);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  function init(HOST, ROOT, wrap){
    var CFG = HOST.dataset;
    var $ = function(id){ return ROOT.getElementById('kc-' + id); };
    var MAX_BYTES = 850 * 1024;
    var files = {R:null, L:null};
    var added = [];   /* champs ajoutes/remplis par le mode simple, pour pouvoir les retirer */

    /* ---------- Styles ---------- */
    var css = document.createElement('style');
    css.textContent =
      '.kc-choice{max-width:560px;margin:8px auto 0;font-family:Inter,system-ui,sans-serif;color:#F2F4F1}' +
      '.kc-choice h2{font-family:"Barlow Condensed",sans-serif;font-weight:700;font-size:24px;' +
      'letter-spacing:.04em;text-transform:uppercase;margin:10px 0 20px;text-align:center;line-height:1.15}' +
      '.kc-opt{display:block;width:100%;text-align:left;margin:0 0 16px;padding:20px 16px 18px;border-radius:14px;' +
      'border:1px solid #3C4A44;background:#141B18;color:#F2F4F1;cursor:pointer;font-family:inherit;position:relative}' +
      '.kc-opt.kc-main{border:2px solid #E8232A;background:rgba(232,35,42,.10)}' +
      '.kc-opt b{display:block;font-family:"Barlow Condensed",sans-serif;font-size:21px;letter-spacing:.05em;text-transform:uppercase}' +
      '.kc-opt span{display:block;margin-top:6px;font-size:14px;color:#B8C2BD;line-height:1.45}' +
      '.kc-badge{position:absolute;top:-11px;right:12px;background:#E8232A;color:#fff;font-size:11px;font-weight:700;' +
      'letter-spacing:.06em;text-transform:uppercase;padding:4px 8px;border-radius:6px}' +
      '.kc-choice .kc-foot{text-align:center;font-size:13px;color:#8A9791;margin:6px 0 0;line-height:1.5}' +
      '.kc-back{display:inline-block;background:none;border:0;color:#B8C2BD;font-size:14px;padding:2px 0 14px;' +
      'cursor:pointer;font-family:Inter,system-ui,sans-serif;text-decoration:underline}' +
      '.kc-simple textarea{width:100%;box-sizing:border-box;background:#1C2622;border:1px solid #3C4A44;color:#F2F4F1;' +
      'border-radius:10px;padding:11px 12px;font:15px Inter,system-ui,sans-serif;resize:vertical}' +
      '.kc-simple .kc-ok{margin:12px 0 0;padding:10px 12px;border-radius:10px;border:1px solid #3FB27F;' +
      'background:rgba(63,178,127,.12);color:#F2F4F1;font-size:14px;line-height:1.45}' +
      '.kc-simple .kc-err{color:#FF8A8E;font-size:14px;margin:10px 0 0;line-height:1.45}' +
      '.wrap.kc-m-choice .grid{display:none!important}' +
      '.wrap:not(.kc-m-choice) .kc-choice{display:none}' +
      '.wrap:not(.kc-m-simple) .kc-simple{display:none}' +
      '.wrap.kc-m-choice .kc-back{display:none}' +
      '.wrap.kc-m-simple .grid{display:block;max-width:560px;margin:0 auto}' +
      '.wrap.kc-m-simple .stage,' +
      '.wrap.kc-m-simple #kc-card3,.wrap.kc-m-simple #kc-card4,.wrap.kc-m-simple #kc-card5,.wrap.kc-m-simple #kc-card6,' +
      '.wrap.kc-m-simple #kc-addBtn,.wrap.kc-m-simple #kc-kcDone,.wrap.kc-m-simple #kc-kcErr,' +
      '.wrap.kc-m-simple #kc-card2 .kc-tip{display:none!important}';
    ROOT.appendChild(css);

    /* ---------- Ecran de choix ---------- */
    var choice = document.createElement('div');
    choice.className = 'kc-choice';
    choice.innerHTML =
      '<h2>Comment veux-tu cr\u00e9er tes prot\u00e8ge-tibias&nbsp;?</h2>' +
      '<button type="button" class="kc-opt kc-main" data-mode="simple">' +
        '<em class="kc-badge">Le plus simple</em>' +
        '<b>\uD83E\uDD1D On fait la maquette pour vous</b>' +
        '<span>Envoie juste tes photos. Notre \u00e9quipe cr\u00e9e ta maquette pour toi.</span>' +
      '</button>' +
      '<button type="button" class="kc-opt" data-mode="self">' +
        '<b>\u270F\uFE0F Je cr\u00e9e ma maquette</b>' +
        '<span>Aper\u00e7u en direct : photo, pr\u00e9nom, num\u00e9ro, police, couleurs, drapeau.</span>' +
      '</button>' +
      '<p class="kc-foot">M\u00eame prix dans les deux cas \u00b7 Fabriqu\u00e9 \u00e0 la main en France</p>';

    var bar = wrap.querySelector('.kc-bar');
    var grid = wrap.querySelector('.grid');
    wrap.insertBefore(choice, grid);

    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'kc-back';
    back.textContent = '\u2190 Changer d\u2019option';
    wrap.insertBefore(back, grid);
    back.addEventListener('click', function(){ setMode('choice'); });

    choice.addEventListener('click', function(e){
      var b = e.target.closest('.kc-opt'); if(!b) return;
      setMode(b.dataset.mode);
    });

    /* ---------- Formulaire simple ---------- */
    var simple = document.createElement('div');
    simple.className = 'kc-simple';
    simple.innerHTML =
      '<section class="card">' +
        '<h2><span class="step-n">3</span> Infos pour ta maquette</h2>' +
        '<div class="field"><label class="lbl" for="kc-sPrenom">Pr\u00e9nom (facultatif)</label>' +
          '<input type="text" id="kc-sPrenom" maxlength="14" placeholder="Ex. Lucas"></div>' +
        '<div class="field"><label class="lbl" for="kc-sNumero">Num\u00e9ro (facultatif)</label>' +
          '<input type="text" id="kc-sNumero" maxlength="3" inputmode="numeric" placeholder="Ex. 10"></div>' +
        '<div class="field"><label class="lbl" for="kc-sNote">Une demande particuli\u00e8re\u00a0? (facultatif)</label>' +
          '<textarea id="kc-sNote" rows="3" maxlength="300" placeholder="Ex. couleurs du club, drapeau du Maroc, pr\u00e9nom seulement \u00e0 droite\u2026"></textarea></div>' +
        '<p class="kc-ok">\u2705 Notre \u00e9quipe r\u00e9alise ta maquette \u00e0 la main \u00e0 partir de tes photos.</p>' +
      '</section>' +
      '<button type="button" class="cta" id="kc-sAdd">Ajouter au panier</button>' +
      '<p class="kc-err" id="kc-sErr" hidden></p>';
    var card2 = $('card2');
    card2.parentNode.insertBefore(simple, card2.nextSibling);

    $('sNumero').addEventListener('input', function(e){ e.target.value = e.target.value.replace(/\D/g, ''); });

    /* On garde les fichiers originaux (l'appli vide le champ apres lecture). */
    ROOT.addEventListener('change', function(e){
      var t = e.target;
      if(!t || !t.files || !t.files[0]) return;
      if(t.id === 'kc-fileR') files.R = t.files[0];
      if(t.id === 'kc-fileL') files.L = t.files[0];
    }, true);

    var mode = 'choice';
    function setMode(m){
      mode = m;
      wrap.classList.toggle('kc-m-choice', m === 'choice');
      wrap.classList.toggle('kc-m-simple', m === 'simple');
      if(m === 'self') clearSimpleFields();
      HOST.scrollTop = 0;
      window.dispatchEvent(new Event('resize'));  /* redessine l'apercu en mode "je cree" */
    }
    setMode('choice');

    /* ---------- Outils ---------- */
    function sameBoth(){ var c = $('sameBoth'); return !c || c.checked; }

    function chosenSize(){
      var b = ROOT.querySelector('#kc-sizes [aria-pressed="true"]');
      if(!b) return null;
      var small = b.querySelector('small');
      var label = (b.firstChild && b.firstChild.nodeType === 3) ? b.firstChild.textContent.trim() : b.textContent.trim();
      return {label: label, cm: small ? small.textContent.trim() : ''};
    }

    function loadImg(file){
      return new Promise(function(res, rej){
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function(){ res(img); };
        img.onerror = function(){ rej(new Error('image illisible')); };
        img.src = url;
      });
    }

    /* Reduit la photo sous la limite d'envoi, en gardant la meilleure qualite possible. */
    async function shrink(file, base){
      if(file.size <= MAX_BYTES && /jpe?g|png/i.test(file.type)){
        return new File([file], base + (/png/i.test(file.type) ? '.png' : '.jpg'), {type: file.type});
      }
      var img = await loadImg(file);
      var steps = [[2200,0.88],[1800,0.85],[1500,0.82],[1200,0.8],[1000,0.75]];
      var last = null;
      for(var i = 0; i < steps.length; i++){
        var max = steps[i][0], q = steps[i][1];
        var k = Math.min(1, max / Math.max(img.width, img.height));
        var cv = document.createElement('canvas');
        cv.width = Math.round(img.width * k);
        cv.height = Math.round(img.height * k);
        var ctx = cv.getContext('2d');
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, cv.width, cv.height);
        ctx.drawImage(img, 0, 0, cv.width, cv.height);
        var blob = await new Promise(function(r){ cv.toBlob(r, 'image/jpeg', q); });
        last = blob;
        if(blob && blob.size <= MAX_BYTES) break;
      }
      if(!last) throw new Error('export vide');
      return new File([last], base + '.jpg', {type: 'image/jpeg'});
    }

    function lightFileInputs(){
      return [].slice.call(document.querySelectorAll('input[type=file]')).filter(function(el){ return !HOST.contains(el); });
    }
    function pick(sel, nth){
      if(sel){ try { return document.querySelector(sel); } catch(e){ return null; } }
      return lightFileInputs()[nth] || null;
    }
    function setFile(input, file){
      if(!input) return false;
      try {
        var dt = new DataTransfer();
        dt.items.add(file);
        input.files = dt.files;
        input.dispatchEvent(new Event('change', {bubbles:true}));
        input.dispatchEvent(new Event('input',  {bubbles:true}));
        return true;
      } catch(e){ return false; }
    }
    function setValue(el, v){
      if(!el) return;
      el.value = v;
      el.dispatchEvent(new Event('change', {bubbles:true}));
      el.dispatchEvent(new Event('input',  {bubbles:true}));
    }

    /* Trouve un ancien champ de l'app d'options d'apres son libelle. */
    function findLegacy(rx){
      var list = [].slice.call(document.querySelectorAll('input[type=text], textarea'))
        .filter(function(f){ return !HOST.contains(f); });
      for(var i = 0; i < list.length; i++){
        var f = list[i], txt = (f.name || '') + ' ' + (f.placeholder || '');
        var lab = null;
        if(f.id){ try { lab = document.querySelector('label[for="' + CSS.escape(f.id) + '"]'); } catch(e){} }
        if(!lab) lab = f.closest('label');
        if(!lab){
          var p = f.previousElementSibling;
          while(p && !/^(LABEL|P|SPAN|DIV|H\d|STRONG|B|LEGEND)$/.test(p.tagName)) p = p.previousElementSibling;
          if(p && (p.textContent || '').trim().length < 80) lab = p;
        }
        if(lab) txt += ' ' + lab.textContent;
        if(rx.test(txt)) return f;
      }
      return null;
    }

    function addProp(form, name, value){
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'properties[' + name + ']';
      i.value = value;
      i.dataset.kcSimple = '1';
      form.appendChild(i);
      added.push({el:i, remove:true});
    }

    function clearSimpleFields(){
      added.forEach(function(a){
        if(a.remove) a.el.remove();
        else setValue(a.el, '');
      });
      added = [];
    }

    async function cartCount(){
      try {
        var r = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
        var j = await r.json();
        return (typeof j.item_count === 'number') ? j.item_count : null;
      } catch(e){ return null; }
    }
    async function waitForCart(before){
      if(before === null){ await new Promise(function(r){ setTimeout(r, 2500); }); return true; }
      var deadline = Date.now() + 15000;
      while(Date.now() < deadline){
        await new Promise(function(r){ setTimeout(r, 600); });
        var now = await cartCount();
        if(now !== null && now > before) return true;
      }
      return false;
    }

    function showErr(msg){
      var e = $('sErr');
      e.textContent = msg;
      e.hidden = !msg;
    }

    /* ---------- Ajout au panier ---------- */
    $('sAdd').addEventListener('click', async function(){
      var btn = $('sAdd');
      showErr('');

      var sz = chosenSize();
      if(!sz){ showErr('Choisis d\u2019abord ta taille (\u00e9tape 1).'); return; }

      var fR = files.R, fL = files.L;
      if(sameBoth()){ fR = fR || fL; fL = fL || fR; }
      if(!fR || !fL){
        showErr(sameBoth() ? 'Ajoute ta photo (\u00e9tape 2).' : 'Ajoute une photo pour le droit et une pour le gauche (\u00e9tape 2).');
        return;
      }

      var form = document.querySelector('form[action*="/cart/add"]');
      var real = null;
      try { real = document.querySelector(CFG.addBtn || 'form[action*="/cart/add"] [type=submit]'); } catch(e){}
      if(!form || !real){ showErr('Un probl\u00e8me est survenu. Recharge la page et r\u00e9essaie.'); return; }

      btn.disabled = true;
      btn.innerHTML = '<span class="kc-spin"></span>Envoi de tes photos\u2026';

      try {
        clearSimpleFields();
        var before = await cartCount();

        var pR = await shrink(fR, 'kingcase-photo-droit');
        var pL = (fL === fR) ? pR : await shrink(fL, 'kingcase-photo-gauche');
        if(fL === fR) pL = new File([pR], pR.name.replace('droit', 'gauche'), {type: pR.type});

        var okR = setFile(pick(CFG.fileRight, 0), pR);
        var okL = setFile(pick(CFG.fileLeft, 1), pL);
        if(!okR && !okL) throw new Error('champs photo introuvables');

        var prenom = $('sPrenom').value.trim();
        var numero = $('sNumero').value.trim();
        var note = $('sNote').value.trim();
        var infos = [prenom, numero].filter(Boolean).join(' \u00b7 ') || '\u2014';

        /* Visible dans le panier et dans la commande Shopify. */
        addProp(form, 'Maquette', '\u00c0 faire par KingCase');
        addProp(form, 'Taille', sz.label + (sz.cm ? ' (' + sz.cm + ')' : ''));
        if(prenom) addProp(form, 'Pr\u00e9nom', prenom);
        if(numero) addProp(form, 'Num\u00e9ro', numero);
        if(note) addProp(form, 'Demande', note);

        /* Remplit aussi les anciens champs de l'app d'options s'ils existent. */
        var fTxt = null, fNote = null;
        try { if(CFG.textPrenom) fTxt = document.querySelector(CFG.textPrenom); } catch(e){}
        if(!fTxt) fTxt = findLegacy(/nom\s*&?\s*num[e\u00e9]ro/i);
        fNote = findLegacy(/envie\s*particuli/i);
        if(fTxt){ setValue(fTxt, 'MAQUETTE A FAIRE \u2014 ' + infos); added.push({el:fTxt}); }
        if(fNote && fNote !== fTxt){ setValue(fNote, 'MAQUETTE A FAIRE PAR KINGCASE' + (note ? ' \u2014 ' + note : '')); added.push({el:fNote}); }
        try {
          if(CFG.textTaille){ var fT = document.querySelector(CFG.textTaille); if(fT){ setValue(fT, sz.label + ' (' + sz.cm + ')'); added.push({el:fT}); } }
        } catch(e){}

        await new Promise(function(r){ setTimeout(r, 700); });
        btn.innerHTML = '<span class="kc-spin"></span>Ajout au panier\u2026';
        real.click();
        var ok = await waitForCart(before);
        if(!ok) throw new Error('panier non mis a jour');

        btn.innerHTML = '\u2713 Ajout\u00e9 au panier';
        btn.classList.add('validated');

        var trig = document.querySelector('button[aria-haspopup="dialog"][data-kc-label]') ||
                   [].slice.call(document.querySelectorAll('button[aria-haspopup="dialog"]'))
                     .filter(function(b){ return /prot/i.test(b.textContent || ''); })[0];
        if(trig){
          trig.textContent = '\u2713 Photos envoy\u00e9es \u2014 modifier';
          trig.style.background = '#3FB27F';
          trig.style.color = '#08150F';
        }
        setTimeout(function(){
          var close = ROOT.querySelector('.kc-close');
          if(close) close.click();
          btn.disabled = false;
          btn.classList.remove('validated');
          btn.textContent = 'Ajouter au panier';
        }, 1400);
      } catch(e){
        console.error('[KingCase simple]', e);
        btn.disabled = false;
        btn.textContent = 'Ajouter au panier';
        showErr('L\u2019ajout au panier n\u2019a pas fonctionn\u00e9. V\u00e9rifie ta connexion et r\u00e9essaie.');
      }
    });
  }
})();
